import Vue from 'vue'
import main from './main.vue'

const MainConstructor = Vue.extend(main)

let instance

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })
  document.body.appendChild(instance.$el)
}

const UploadFile = function (options = {}) {
  if (!instance) {
    initInstance()
  }
  for (const key in options) {
    if (instance.hasOwnProperty(key)) {
      instance[key] = options[key]
    }
  }
  instance.visible = true
}

UploadFile.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default UploadFile
export { UploadFile }



// WEBPACK FOOTER //
// ./src/views/question-review/components/UploadFile/src/main.js